



















import { Component, Vue } from 'vue-property-decorator'

import AuthModal from '@/components/AuthModal.vue'
import RegistrationForm from '@/components/RegistrationForm.vue'

import RegistrationData from '@/models/registration-data'

import { AuthActionTypes } from '@/store/modules/auth/actions'

@Component({
  components: {
    AuthModal,
    RegistrationForm,
  },
})
export default class Registration extends Vue {
  get errors() {
    return this.$store.getters.getRegistrationPageErrors
  }

  get formPending() {
    return this.$store.getters.getRegistrationPagePending
  }

  onRegistration(registrationData: RegistrationData) {
    const redirectTo = '/'
    this.$store.dispatch(AuthActionTypes.Registration, {
      registrationData,
      redirectTo,
    })
  }
}
